import { getCookie, deleteCookie, setCookie } from "../utils/cookie";
import { refresh_token, user_init } from "./endpoints";
import { permissions } from "./permissions";

export const checkSession = async (
  updateContext,
  navigateUrl,
  requestFetch
) => {
  let session = getCookie("session_cookie");

  const current_path =
    permissions.find((x) => x.href === window.location.pathname) ||
    permissions.find((x) => x.is_index);

  let is_white_list_url =
    current_path.permission.includes("ALL") &&
    current_path.redirect_session === null;

  !current_path.permission.includes("ALL") && current_path.need_session;

  let is_frame_parent = current_path.is_frame_parent;

  if (session) {
    session = JSON.parse(session);
    let response = await requestFetch(
      "get",
      user_init,
      null,
      session.token,
      true
    );
    if (response.result) {
      is_white_list_url =
        !current_path.permission.includes("ALL") &&
        current_path.permission.includes(response.data.profileTypeCode);
      const current_session = { session: { ...response.data, ...session } };
      updateContext(current_session);

      // if (current_session?.session && !current_session.session.privacyConsent)
      //   context.openModal(<PrivacyConsentUser context={context} />);

      if (!is_white_list_url) {
        navigateUrl("/");
      }
    } else {
      refreshToken(
        session,
        updateContext,
        navigateUrl,
        requestFetch,
        is_white_list_url,
        is_frame_parent
      );
    }
  } else if (!is_white_list_url) {
    if (!is_frame_parent) navigateUrl("/login");
    else window.parent.postMessage({ session_expired: true }, "*");
  }
};

const refreshToken = async (
  session,
  updateContext,
  navigateUrl,
  requestFetch,
  is_white_list_url,
  is_frame_parent
) => {
  let refresh_response;
  if (getCookie("remember_session")) {
    refresh_response = await requestFetch(
      "get",
      refresh_token,
      null,
      session.refreshToken,
      true
    );
  }

  if (!!refresh_response && refresh_response?.result) {
    setCookie(
      "session_cookie",
      JSON.stringify({
        token: refresh_response.data.token,
        refreshToken: session.refreshToken,
      })
    );
    let response = await requestFetch(
      "get",
      user_init,
      null,
      refresh_response.data.token,
      true
    );

    if (response.result) {
      updateContext({
        session: {
          ...response.data,
          ...refresh_response.data,
          refreshToken: session.refreshToken,
        },
      });
    } else if (!is_white_list_url) {
      if (!is_frame_parent) navigateUrl("/login");
      else window.parent.postMessage({ session_expired: true }, "*");
    }
  } else {
    localStorage.removeItem("last_container_viewed");
    deleteCookie("session_cookie");
    deleteCookie("pv_impersonate");
    deleteCookie("remember_session");
    updateContext({ session: null });
    if (!is_white_list_url) {
      if (!is_frame_parent) navigateUrl("/login");
      else window.parent.postMessage({ session_expired: true }, "*");
    }
  }
};
